






































import { GetInstanceTransactionResponse } from "@/classes/TayehApi/Instance";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class InvoiceViewerPrice extends Vue {
    @Prop() type: 'bought'|'sold'|'income'|'cost';
    @Prop() delivery: any;
    @Prop() payment: any;
    @Prop() total: number;
    @Prop() transactions: GetInstanceTransactionResponse[];

    
    public get productsValue() : number {        
        return this.transactions.map(transaction => transaction.value_without_off*transaction.count).reduce((sum, value) => sum+value, 0)||0;
    }

    public get offValue() : number|string {        
        const price =  this.transactions.map(transaction => transaction.value_without_off*transaction.count).reduce((sum, value) => sum+value, 0)||0;
        return (this.productsValue-price)||'-';
    }

    public get isATrade() : boolean {
        return ['bought', 'sold'].indexOf(this.type)!==-1;
    }
    
    public get totalLabel() : string {
        return {
            bought: 'مبلغ قابل پرداخت',
            sold: 'جمع کل',
            income: 'جمع کل',
            cost: 'جمع کل',
            rb: 'جمع کل',
            rs: 'جمع کل',
        }[this.type];
    }

    public get productsValueLabel() : string {
        return {
            bought: 'قیمت محصولات',
            sold: 'قیمت محصولات',
            income: 'جمع درآمدها',
            cost: 'جمع هزینه ها',
            rb: 'جمع بازگشتی',
            rs: 'جمع بازگشتی',
        }[this.type];
    }
    
    
}
